import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import {
  Title,
  RowCustom,
  ButtonLink,
  CarouselResponsive,
} from 'components';

import {
  CardPopularWrapper,
  CardPopularOverlay,
  CardPopular,
  CardPopularInfo,
} from '../Main.styles';

const PopularDirections = ({ dataPopular }) => {
  const intl = useIntl();

  return (
    <CardPopularWrapper>
      <CarouselResponsive
        responsive={[
          {
            breakpoint: 2500,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: true,
              dots: false,
              centerMode: true,
              centerPadding: '90px',
            },
          },
          {
            breakpoint: 1640,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false,
              centerMode: true,
              centerPadding: '90px',
            },
          },
          {
            breakpoint: 1350,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: false,
              centerMode: true,
              centerPadding: '90px',
            },
          },
          {
            breakpoint: 850,
            settings: {
              centerMode: true,
              centerPadding: '190px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 770,
            settings: {
              centerMode: true,
              centerPadding: '140px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 770,
            settings: {
              centerMode: true,
              centerPadding: '100px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ]}
        padding="25px 0"
      >
        {dataPopular
          && dataPopular.featuredRegions.map(
            ({
              country, coverPhoto, name, url, propertiesCount, price,
            }) => (
              <div>
                <CardPopularWrapper>
                  <Link to={`${url}`} target="_blank">
                    <CardPopular
                      bgImg={`${process.env.REACT_APP_API_MEDIA_URL}${coverPhoto}`}
                      width="42vw"
                      height="37vw"
                      // widthLaptop
                    >
                      <CardPopularOverlay />
                      <CardPopularInfo>
                        <Title size="24px" color="#fff">
                          {name}
                          {/* {', '} */}
                          {country}
                        </Title>
                        <RowCustom justify="space-between" width="100%">
                          <Title size="16px" color="#fff">
                            {propertiesCount}
                            {' '}
                            {intl.formatMessage({
                              id:
                                'main-page.popular-direction-card.appartments',
                            })}
                          </Title>
                          <Title size="16px" color="#fff">
                            {intl.formatMessage({
                              id: 'main-page.popular.price-from',
                            })}
                            {price}
                            {' '}
                            €
                          </Title>
                        </RowCustom>
                      </CardPopularInfo>
                    </CardPopular>
                  </Link>
                </CardPopularWrapper>
              </div>
            ),
          )}
      </CarouselResponsive>
      {/* <ButtonLink
        // style={{ opacity: 0 }}
        margin="70px auto 40px auto"
        // margin="70px auto 120px auto"
        size="16px"
        size="16px"
        width="190px"
        height="48px"
        marginSM="70px auto 30px auto"
        display="block"
        primary
        target="blank"
        to={`${localStorage.language}/destinations`}
      >
        {intl.formatMessage({
          id: 'buttons.all-directions',
        })}
      </ButtonLink> */}
    </CardPopularWrapper>
  );
};

export { PopularDirections };
